module.exports = __webpack_public_path__ + "img/2092839.a843e06a.jpg";